const freezePageScroll = () => document.querySelector('body').classList.add('gdc-scroll-freeze');
const unfreezePageScroll = () => document.querySelector('body').classList.remove('gdc-scroll-freeze');

// ========= Component: section-overlapping-images-custom ============= //

const _popupVideoSection = () => document.querySelector('section.gdc-overlapping-images__popup-video');
const _popupVideo = () => _popupVideoSection().querySelector('video');
const _popupVideoSrc = () => _popupVideoSection().querySelector('source');

function openVideoPopup(url) {
  _popupVideoSection().style.display = 'flex';
  _popupVideoSrc().setAttribute('src', url);
  _popupVideo().load();
  freezePageScroll();
}

const closeVideoPopup = (event) => {
  event.target.closest('.gdc-overlapping-images__popup-video').style.display = 'none';
  _popupVideo().pause();
  unfreezePageScroll();
};

function videoHTML() {
  return `
    <section class="gdc-overlapping-images__popup-video">
      <div class="gdc-overlapping-images__popup-video-close" onclick="closeVideoPopup(event)">CLOSE <span>X</span></div>
      <video controls autoplay>
        <source src="">
      </video>
    </section>
  `;
}

function handleVideoPopup(event) {
  event.preventDefault();
  const videoUrl = event.target.parentElement.href;

  openVideoPopup(videoUrl);
}

window.addEventListener('load', () => {
  document.body.insertAdjacentHTML('afterbegin', videoHTML());
});

// ==================   CART UPSELL COMPONENT ===============================

async function addAddonToCart(variantId, quantity = 1) {
  const result = await fetch('/cart/add.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: {type: 'addon'}
    })
  });
}

async function updateItem(data) {
  const result = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
}

function updateCartByItemId(lineItemId, newQuantity) {
  return updateItem({
    id: lineItemId.toString(),
    quantity: newQuantity,
    properties: {}
  });
}

function removeUpsellItem(event) {
  const item = event.target.closest('.gdc-cart-upsell__item');

  item.classList.add('gdc-cart-upsell__item-slideout');
  // timeout to wait for cart object to update
  setTimeout(() => {
    item.style.display = 'none';
  }, 1100);
}

async function getCart() {
  const result = await fetch('/cart.json');

  if (result.status === 200) {
    const data = result.json();
    return data;
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

function addDecimal(num) {
  if (num === 0) {
    return 'FREE';
  }
  var leftDecimal = num.toString().replace('.', ''),
    rightDecimal = '00';

  if (leftDecimal.length > 2) {
    rightDecimal = leftDecimal.slice(-2);
    leftDecimal = leftDecimal.slice(0, -2);
  }

  var n = Number(leftDecimal + '.' + rightDecimal).toFixed(2);
  return n === 'NaN' ? num : `$${n}`;
}

function cartItemHTML(item) {
  const properties = item.properties;

  function variantHtml(v) {
    return `<p class="cart__item__selected-options">
            <span>${v}</span>
          </p>`;
  }

  function addonHtml(key, display) {
    return `<p class="cart__item__property" style="display: none;">
              <span>${key}: </span><span>${properties[key]} </span>
            </p>`;
  }

  const variantTitle = () => (item.variant_title ? variantHtml(item.variant_title) : '');

  const lineProperties = Object.keys(properties)
    .map((key) => {
      let isAddon = properties[key].includes('addon');
      return isAddon ? addonHtml(key, 'none') : addonHtml(key, 'block');
    })
    .join('');

  const itemPrice = item.price == 'Free' ? 'FREE' : item.price;

  const modifierClass = item.id === 42519505502373 ? 'free-sample' : '';

  const quantityModifierClass = item.id === 42519505502373 ? 'hidden' : '';

  return `<div class="cart__item" data-cart-item>
            <div class="cart__item__image">
              <a href="${
                item.url
              }"><img class="lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${
    item.image
  }" data-aspectratio="1.552665799739922" data-widths="[90,160,180,270,320]" data-sizes="auto" alt="${
    item.title
  }" loading="lazy" width="auto" height="auto">
                <noscript>
                  <img src="${item.image}" alt="${item.title}" loading="lazy"
                    width="auto" height="auto">
                </noscript>
              </a>
            </div>

            <div class="cart__item__content">
              <div class="cart__item__content-inner">
                <div class="cart__item__info">
                  <p class="cart__item__title">
                    <a href="${item.url}">${item.title}</a>
                  </p>

                  <div class="cart__item__meta">
                  ${variantTitle()}
                  ${lineProperties}
                  </div>
                </div>

                <p class="cart__item__price">${addDecimal(itemPrice)}</p>
              </div>

              <div class="cart__item__bottom ${modifierClass}">

                <div class="cart__item__quantity ${quantityModifierClass}" data-quantity-holder>
                    <button type="button" onclick="customUpdateCart(event, ${
                      item.id
                    })" class="cart__item__quantity-minus" data-quantity-minus data-quantity-button title="Decrease Quantity - ${
    item.title
  }">
                      <span class="visually-hidden">Decrease Quantity</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 19 20"><path d="M10.725 11.02h6.671c.566 0 1.03-.506 1.03-1.072 0-.565-.464-1.07-1.03-1.07H1.953c-.566 0-1.029.505-1.029 1.07 0 .566.463 1.072 1.029 1.072h8.772z"></path></svg></button>

                      <input type="number" name="updates[]" id="updates_${
                        item.key
                      }" class="cart__item__quantity-field gdc-cart__item__quantity-field" data-quantity-field data-id="${
    item.key
  }" value="${item.quantity}" title="Quantity - ${item.title}" pattern="[0-9]*">

                    <button type="button" onclick="customUpdateCart(event, ${
                      item.id
                    })" class="cart__item__quantity-plus" data-quantity-plus data-quantity-button title="Increase Quantity - ${
    item.title
  }">
                      <span class="visually-hidden">Increase Quantity</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 19 20"><path d="M10.725 11.02h6.671c.566 0 1.03-.506 1.03-1.072 0-.565-.464-1.07-1.03-1.07h-6.67V2.27c0-.565-.506-1.029-1.072-1.029-.566 0-1.071.464-1.071 1.03v6.605h-6.63c-.566 0-1.029.506-1.029 1.071 0 .566.463 1.072 1.029 1.072h6.63v6.695c0 .566.505 1.03 1.07 1.03.566 0 1.072-.464 1.072-1.03V11.02z"></path></svg></button>
                  </div>

                <a href="javascript:void(0)" class="cart__item__remove" title="Remove" aca-line="1" onclick="customCartItemRemove(event, '${
                  item.key
                }')">
                  <span>Remove</span>
                </a>
              </div>
            </div>
        </div>`;
}

function setCartQuantityNotification() {
  const cartQuantity = document.querySelector('.cart-drawer__item-qty');
  // timeout to wait for cart object to update
  setTimeout(() => {
    getCart().then((data) => {
      updateFreeSample(data);
      cartQuantity.innerHTML = `${data.item_count} ${data.item_count > 1 ? `items` : `item`}`;
    });
  }, 500);
}

function setButtonPrice(num) {
  const cartButtonPrice = document.querySelector('.cart__total__money');
  cartButtonPrice.innerHTML = `${addDecimal(num)}`;
}

function unHideCartFooter() {
  const cartFooter = document.querySelector('.cart-drawer__foot');
  cartFooter.classList.remove('hidden');
}

function unHideCartItemsWrapper() {
  const cartItemsWrapper = document.querySelector('.cart-drawer__items');
  cartItemsWrapper.classList.remove('hidden');
}

function removeCartEmptyNotice() {
  const message = document.querySelector('.gdc-empty-cart-message');
  if (message) {
    message.remove();
  }
}

function setInitialCartData() {
  const cartItemsWrapper = document.querySelector('.cart-drawer__items');
  // timeout to wait for cart object to update
  setTimeout(() => {
    setCartQuantityNotification();
    removeCartEmptyNotice();
    getCart().then((data) => {
      updateFreeSample(data);
      setButtonPrice(data.total_price);
      for (const item of data.items) {
        cartItemsWrapper.insertAdjacentHTML('beforeend', cartItemHTML(item));
      }
    });
  }, 1000);
}

function removeCartItems() {
  const cartItems = document.querySelectorAll('.cart-drawer__items .cart__item');
  // timeout to wait for cart object to update
  setTimeout(() => {
    cartItems.forEach((item) => {
      item.remove();
    });
  }, 500);
}

function hideCartEmptyMessage() {
  const cartEmptyMessage = document.querySelector('.cart-drawer__empty-message');
  cartEmptyMessage.classList.add('hidden');
}

function replaceCartPopoutInfo() {
  unHideCartFooter();
  hideCartEmptyMessage();
  removeCartItems();
  unHideCartItemsWrapper();
  setInitialCartData();
}

function customAddToCart(event, variantId) {
  addAddonToCart(variantId);
  removeUpsellItem(event);
  replaceCartPopoutInfo();
}

function customUpdateCart(event, variantId) {
  const buttonClicked = event.target;
  const quantityInput = buttonClicked.closest('.cart__item__quantity').querySelector('.gdc-cart__item__quantity-field');
  const quantity = parseInt(quantityInput.value);
  const inputAddOne = () => (quantityInput.value = quantity + 1);
  const inputMinusOne = () => (quantityInput.value = quantity - 1);

  if (buttonClicked.classList.contains('cart__item__quantity-plus')) {
    updateCartByItemId(variantId, quantity + 1);
    inputAddOne();
    setCartQuantityNotification();
  }

  if (buttonClicked.classList.contains('cart__item__quantity-minus') && quantity > 0) {
    updateCartByItemId(variantId, quantity - 1);
    inputMinusOne();
    setCartQuantityNotification();
  }
}

function removeCartItem(event) {
  const item = event.target.closest('.cart__item');
  // timeout to wait for cart object to update
  setTimeout(() => {
    item.style.display = 'none';
  }, 500);
}

function updateFreeSample(data) {
  if (!data) return;
  const cart = document.getElementById('cart-drawer');
  if (cart) {
    const freeSampleId = cart.getAttribute('data-free-sample')
      ? parseInt(cart.getAttribute('data-free-sample'), 10)
      : null;
    if (freeSampleId) {
      let sampleFound = false;
      const upsell = document.querySelector('.gdc-cart-upsell.free-sample');
      data.items.forEach((item) => {
        if (item.id === freeSampleId) {
          if (upsell) {
            sampleFound = true;
            upsell.style.display = 'none';
          }
        }
      });
      if (sampleFound === false && upsell) {
        const card = upsell.querySelector('.gdc-cart-upsell__item-slideout');
        if (card) {
          card.classList.remove('gdc-cart-upsell__item-slideout');
          card.style.display = 'flex';
        }
        if (upsell) upsell.style.display = 'block';
      }
      const productPageSubmit = document.querySelector('button[data-free-sample]');
      if (productPageSubmit) {
        window.location.reload();
      }
    }
  }
}

function customCartItemRemove(event, variantId) {
  updateCartByItemId(variantId, 0);
  removeCartItem(event);
  setCartQuantityNotification();
  getCart().then((data) => {
    updateFreeSample(data);
    setButtonPrice(data.total_price);
  });
}

function handleUpsellVisibility() {
  let hideUpsellComponent = true;
  const upsellComponent = document.querySelectorAll('.gdc-cart-upsell:not(.free-sample)');
  upsellComponent.forEach((component) => {
    const upsellItems = component.querySelectorAll('.gdc-cart-upsell__item');
    upsellItems.forEach((item, indx) => {
      if (!item.classList.contains('gdc-cart-upsell__item-slideout')) {
        hideUpsellComponent = false;
      }
      // Confirms only 3 addons will show
      if (indx > 2) {
        item.remove();
      }
    });
    if (hideUpsellComponent === true) component.style.display = 'none';
  });
}

function observeIfUpsellItems() {
  const targetNode = document.getElementById('cart-drawer');
  const config = {childList: true, subtree: true};

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        //console.log('A child node has been added or removed.');
      } else if (mutation.type === 'attributes') {
        //console.log(`The ${mutation.attributeName} attribute was modified.`);
      }
    }

    handleUpsellVisibility();
  };

  if (targetNode) {
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

function handleCartDrawerAddonCounter() {
  const drawer = document.querySelector('#cart-drawer');
  const config = {attributes: true};

  // Observe when drawer attribute changes to visible
  const callback = (mutationList, observer) => {
    removeCartPropertyAddons();
  };

  if (drawer) {
    const observer = new MutationObserver(callback);
    observer.observe(drawer, config);
  }
}

function removeCartPropertyAddons() {
  const properties = document.querySelectorAll('.cart__item__property');

  if (properties) {
    properties.forEach((property) => {
      property.childNodes.forEach((node) => {
        let isAddonProperty = () => node.innerHTML && node.innerHTML.includes('addon');
        if (isAddonProperty()) {
          property.style.display = 'none';
        }
      });
    });
  }
}

window.addEventListener('load', observeIfUpsellItems);
window.addEventListener('DOMContentLoaded', removeCartPropertyAddons);
window.addEventListener('DOMContentLoaded', handleCartDrawerAddonCounter);
